import {
  DEFAULT_PRINT_PAGE_SIZE,
  isValidPrintPageSize,
} from 'constants/printPageSize';
import { getItemFromStore, setItemToStore } from 'helpers/utils';

/** Last page size the user printed with for `storageKey` (falls back to the 4×6 label). */
export const getPreferredPrintPageSize = storageKey => {
  const stored = getItemFromStore(storageKey, DEFAULT_PRINT_PAGE_SIZE);
  return isValidPrintPageSize(stored) ? stored : DEFAULT_PRINT_PAGE_SIZE;
};

export const savePreferredPrintPageSize = (storageKey, pageSize) => {
  if (isValidPrintPageSize(pageSize)) {
    setItemToStore(storageKey, pageSize);
  }
};
